// Локализация UI Кубикон CAD на русском.
// Все строки интерфейса собраны здесь — позже можно сделать i18next и переключение языков.

const RU = {
    appTitle: 'Кубикон CAD',
    appSubtitle: 'Параметрический 3D-редактор',

    // === Верхняя панель (вкладки-категории) ===
    toolbar: {
        sketch: 'Эскиз',
        create: 'Создать',
        modify: 'Изменить',
        construct: 'Построить',
        inspect: 'Анализ',
        insert: 'Вставить',
        make: 'Изготовить',
        select: 'Выбрать',
        addins: 'Дополнения',
    },

    // === Меню «Создать» ===
    create: {
        newComponent: 'Новый компонент',
        newSketch: 'Создать эскиз',
        createForm: 'Создать поверхность T-Spline',
        derive: 'Производное',
        extrude: 'Выдавить',
        text3d: 'Текст',
        revolve: 'Вращение',
        sweep: 'Сдвиг по траектории',
        loft: 'Лофт',
        rib: 'Ребро',
        web: 'Перемычка',
        emboss: 'Тиснение',
        hole: 'Отверстие',
        thread: 'Резьба',
        pipe: 'Труба',
        box: 'Параллелепипед',
        cylinder: 'Цилиндр',
        sphere: 'Сфера',
        torus: 'Тор',
        coil: 'Спираль',
        pattern: 'Массив',
        rectPattern: 'Прямоуг. массив',
        circPattern: 'Круговой массив',
        mirror: 'Зеркало',
        thicken: 'Утолщение',
        boundaryFill: 'Заливка по границам',
        createMesh: 'Создать сетку',
        meshSectionSketch: 'Эскиз сечения сетки',
        baseFeature: 'Базовый элемент',
        pcb3d: '3D печатная плата',
    },

    // === Меню «Изменить» ===
    modify: {
        pressPull: 'Нажать/Тянуть',
        fillet: 'Скругление',
        chamfer: 'Фаска',
        shell: 'Оболочка',
        draft: 'Уклон',
        scale: 'Масштаб',
        combine: 'Логические операции',
        offsetFace: 'Сместить грань',
        offset: 'Смещение поверхности',
        replaceFace: 'Заменить грань',
        splitFace: 'Разделить грань',
        splitBody: 'Разделить тело',
        silhouetteSplit: 'Силуэт',
        delete: 'Удалить',
        remove: 'Убрать',
        physicalMaterial: 'Физический материал',
        appearance: 'Внешний вид',
        manageMaterials: 'Управление материалами',
        moveCopy: 'Переместить',
        align: 'Выровнять',
        changeParameters: 'Изменить параметры',
        computeAll: 'Вычислить все',
    },

    // === Меню «Построить» (вспомогательная геометрия) ===
    construct: {
        offsetPlane: 'Плоскость со смещением',
        planeAtAngle: 'Плоскость под углом',
        tangentPlane: 'Касательная плоскость',
        midplane: 'Срединная плоскость',
        planeThroughThree: 'Плоскость через 3 точки',
        planeOnPath: 'Плоскость по пути',
        axisFromCylinder: 'Ось через цилиндр',
        axisPerpendicular: 'Перпендикулярная ось',
        axisThroughTwoPoints: 'Ось через 2 точки',
        axisThroughEdge: 'Ось через ребро',
        pointAtCenter: 'Точка в центре',
        pointAtIntersection: 'Точка пересечения',
        coordSystem: 'Локальная система координат',
    },

    // === Эскиз — инструменты рисования ===
    sketch: {
        line: 'Линия',
        rectangle: 'Прямоугольник',
        rectangleCorners: 'Прямоугольник по углам',
        rectangleCenter: 'Прямоугольник из центра',
        circle: 'Окружность',
        circleCenter: 'Окружность по центру',
        circleByThree: 'Окружность по 3 точкам',
        arc: 'Дуга',
        arcThreePoint: 'Дуга по 3 точкам',
        arcCenter: 'Дуга по центру',
        polygon: 'Многоугольник',
        spline: 'Сплайн',
        ellipse: 'Эллипс',
        slot: 'Паз',
        point: 'Точка',
        text: 'Текст',
        filletSketch: 'Скругление',
        trim: 'Обрезать',
        extend: 'Продлить',
        offset: 'Смещение',
        mirror: 'Зеркало',
        pattern: 'Массив',
        project: 'Проецировать',
        sketchDimension: 'Размер',
        constructionLine: 'Вспомогательная линия',
        finish: 'Завершить эскиз',
    },

    // === Ограничения эскиза ===
    constraints: {
        horizontal: 'Горизонталь',
        vertical: 'Вертикаль',
        parallel: 'Параллельность',
        perpendicular: 'Перпендикулярность',
        coincident: 'Совпадение',
        tangent: 'Касание',
        equal: 'Равенство',
        symmetric: 'Симметрия',
        midpoint: 'Средняя точка',
        concentric: 'Концентричность',
        collinear: 'Коллинеарность',
        fix: 'Фиксация',
        smooth: 'Гладкое сопряжение',
    },

    // === Параметры операций (правая панель) ===
    operationParams: {
        profile: 'Профиль',
        start: 'Начало',
        direction: 'Направление',
        directionOne: 'В одну сторону',
        directionTwo: 'В обе стороны',
        directionSymmetric: 'Симметрично',
        extent: 'Тип',
        extentDistance: 'Расстояние',
        extentToObject: 'До объекта',
        extentAll: 'Насквозь',
        distance: 'Расстояние',
        taperAngle: 'Угол сужения',
        operation: 'Операция',
        opNew: 'Новое тело',
        opJoin: 'Объединить',
        opCut: 'Вырезать',
        opIntersect: 'Пересечение',
        objectsToCut: 'Объекты для вычитания',
        axis: 'Ось',
        angle: 'Угол',
        radius: 'Радиус',
        edges: 'Рёбра',
        faces: 'Грани',
        ok: 'OK',
        cancel: 'Отмена',
    },

    // === Браузер (дерево слева) ===
    browser: {
        document: 'Документ',
        documentSettings: 'Настройки документа',
        namedViews: 'Сохранённые виды',
        origin: 'Начало координат',
        planes: 'Плоскости',
        axes: 'Оси',
        bodies: 'Тела',
        sketches: 'Эскизы',
        construction: 'Вспомогательная геометрия',
        materials: 'Материалы',
    },

    // === Меню «Вид» / ViewCube ===
    view: {
        top: 'Сверху',
        bottom: 'Снизу',
        front: 'Спереди',
        back: 'Сзади',
        left: 'Слева',
        right: 'Справа',
        home: 'Исходный вид',
        fitView: 'По размеру окна',
        orbit: 'Вращение',
        pan: 'Перемещение',
        zoom: 'Масштаб',
        ortho: 'Ортогональная проекция',
        perspective: 'Перспектива',
    },

    // === Файл / меню «Изготовить» ===
    file: {
        new: 'Новый',
        open: 'Открыть',
        save: 'Сохранить',
        saveAs: 'Сохранить как',
        export: 'Экспорт',
        exportSTL: 'Экспорт в STL (для печати)',
        exportSTEP: 'Экспорт в STEP (для CAD)',
        exportOBJ: 'Экспорт в OBJ (для 3D-программ)',
        importSTEP: 'Импорт STEP / IGES',
        importSTL: 'Импорт STL / OBJ',
        recent: 'Недавние проекты',
    },

    // === Прочее UI ===
    common: {
        loading: 'Загрузка ядра CAD…',
        loadingHint: 'Это занимает несколько секунд при первом открытии.',
        loadingError: 'Не удалось загрузить ядро. Перезагрузи страницу.',
        unsaved: '(несохранённый)',
        recovered: '(~восстановлен)',
        timeline: 'Хронология построения',
        properties: 'Свойства',
        comments: 'Комментарии',
        emptyTimeline: 'История пуста — начни с создания эскиза',
        confirmDelete: 'Удалить выбранное?',
        ok: 'OK',
        cancel: 'Отмена',
        apply: 'Применить',
        close: 'Закрыть',
        edit: 'Редактировать',
        hide: 'Скрыть',
        show: 'Показать',
        rename: 'Переименовать',
        copy: 'Копировать',
        paste: 'Вставить',
        undo: 'Отменить',
        redo: 'Повторить',
        ctrlZ: 'Ctrl+Z',
        ctrlY: 'Ctrl+Y',
        ctrlS: 'Ctrl+S',
        backToCourses: '← К курсам',
    },

    // === Параметры пользователя ===
    parameters: {
        title: 'Параметры',
        addParam: 'Добавить параметр',
        name: 'Имя',
        expression: 'Выражение',
        value: 'Значение',
        unit: 'Единицы',
        comment: 'Комментарий',
        unitMm: 'мм',
        unitCm: 'см',
        unitM: 'м',
        unitDeg: '°',
    },
};

export default RU;
